module.exports = __webpack_public_path__ + "fonts/montserrat-extralight-webfont.8f097d8.woff2";